module.exports = __webpack_public_path__ + "static/media/Maven_4540.d87d1efb.jpg";